import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs, Controller } from "swiper/modules";
import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import "swiper/css";
import "swiper/css/navigation";
import ButtonBlock from "./ButtonBlock";

import BrandLogoWrapper from "../img/brand-logo-wrapper.svg";
import BrandLogoShadow from "../img/logo-shadow.webp";

const ThumbnailSliderTemplate = ({ data }) => {
  const [thumbsSwiper, setThumbsSwiper] = React.useState(null);
  const [mainSwiper, setMainSwiper] = React.useState(null);

  const trails = data.allMarkdownRemark.edges.map((edge) => ({
    brandImage: getImage(edge.node.frontmatter.trail.thumbnail),
    brandName: edge.node.frontmatter.title,
    image: getImage(edge.node.frontmatter.featuredImage) || getImage(edge.node.frontmatter.image),
    buttonText: "Trail Info",
    buttonLink: edge.node.fields.slug,
    description: edge.node.frontmatter.summary,
  }));

  return (
    <div className="hcs-thumbnail-slider">
      <div className="content">
        <h2 className="section__title is-size-1 is-size-3-mobile is-uppercase mb-2 mt-5">
          Trails we shuttle
        </h2>
      </div>
      <div className="swiper slider-2-thumbs slider__brand">
        <div className="slider__brand-logo-active-wrapper">
          <div className="slider__brand-active-frame">
            <img
              src={BrandLogoWrapper}
              alt=""
              className="slider__brand-logo-border"
            />
            <img
              src={BrandLogoShadow}
              alt=""
              className="slider__brand-logo-shadow"
            />
          </div>
        </div>
        <Swiper
          modules={[Navigation, Thumbs, Controller]}
          onSwiper={setThumbsSwiper}
          slidesPerView="auto"
          spaceBetween={0}
          grabCursor={true}
          centeredSlides={true}
          centerInsufficientSlides={true}
          slideToClickedSlide={true}
          watchSlidesProgress={true}
          resistance={false}
          speed={400}
          touchRatio={1}
          initialSlide={0}
          className="slider__brand-wrapper"
          controller={{ control: mainSwiper }}
        >
          {trails.map((slide, index) => (
            <SwiperSlide key={index} className="slider__brand-logo-item">
              <div className="slider__brand-logo-wrapper">
                {slide.brandImage && (
                  <>
                    <div className="slider__brand-logo">
                      <GatsbyImage
                        image={slide.brandImage}
                        alt={slide.brandName}
                        objectFit="contain"
                        style={{ width: "100%", height: "100%" }}
                      />
                    </div>
                    <div className="slider__brand-name">{slide.brandName}</div>
                  </>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
      <div className="slider__main-wrapper">
        <Swiper
          modules={[Navigation, Thumbs, Controller]}
          onSwiper={setMainSwiper}
          slidesPerView={1}
          effect="slide"
          speed={400}
          observer={true}
          observeParents={true}
          navigation={{
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          }}
          className="slider-2-main slider__main"
          controller={{ control: thumbsSwiper }}
          slideToClickedSlide={true}
          watchSlidesProgress={true}
        >
          {trails.map((slide, index) => (
            <SwiperSlide key={index} className="slider__main-item">
              <div className="slider__wrapper">
                <div className="slider-image">
                  {slide.image && (
                    <GatsbyImage image={slide.image} alt={slide.brandName} />
                  )}
                </div>
                <ButtonBlock
                  className="mx-auto"
                  text={slide.buttonText}
                  link={slide.buttonLink}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
        {/* Navigation arrows remain the same */}
      </div>
    </div>
  );
};

const ThumbnailSlider = () => (
  <StaticQuery
    query={graphql`
      query ThumbnailSliderQuery {
        allMarkdownRemark(
          sort: { frontmatter: { meta: { sortOrder: ASC } } }
          filter: { frontmatter: { templateKey: { eq: "mtb-shuttles-post" } } }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                summary
                featuredImage {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 100
                      width: 960
                      height: 540
                      layout: CONSTRAINED
                      transformOptions: {
                        fit: COVER
                        cropFocus: ATTENTION
                      }
                      placeholder: BLURRED
                    )
                  }
                }
                image {
                  childImageSharp {
                    gatsbyImageData(
                      quality: 100
                      width: 960
                      height: 540
                      layout: CONSTRAINED
                      transformOptions: {
                        fit: COVER
                        cropFocus: ATTENTION
                      }
                      placeholder: BLURRED
                    )
                  }
                }
                trail {
                  thumbnail {
                    childImageSharp {
                      gatsbyImageData(
                        quality: 100
                        layout: FULL_WIDTH
                        placeholder: BLURRED
                      )
                    }
                  }
                  related {
                    trails {
                      image {
                        childImageSharp {
                          gatsbyImageData(
                            quality: 100
                            layout: FULL_WIDTH
                            placeholder: BLURRED
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={(data) => <ThumbnailSliderTemplate data={data} />}
  />
);

export default ThumbnailSlider;
